import { useThemeStore } from '@globals/themes/useThemeStore'
import { ToasterUI } from '@globals/toaster/ToasterUI'
import { useFeatureFlags } from '@globals/useFeatureFlags'
import { LanguagesEnum } from '@kudos/http-client'
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider'
import { PickersLocaleText } from '@mui/x-date-pickers-pro/locales'
import { useT } from '@transifex/react'
import { setDefaultOptions } from 'date-fns'
import { Locale, de, enUS, es, fr, zhCN } from 'date-fns/locale'
import { ReactNode } from 'react'

// Ref: https://mui.com/x/react-date-pickers/adapters-locale/#with-date-fns
export const localeMap: Record<LanguagesEnum, Locale> = {
  [LanguagesEnum.ENGLISH]: enUS,
  [LanguagesEnum.SPANISH]: es,
  [LanguagesEnum.FRENCH]: fr,
  [LanguagesEnum.SIMPLIFIED_CHINESE]: zhCN,
  [LanguagesEnum.GERMAN]: de,
} as const

const AppLayout = ({
  children,
  languageKey,
}: {
  children: ReactNode
  languageKey: LanguagesEnum
}) => {
  const t = useT()

  // Must listen to this to trigger render when the theme changes
  useThemeStore(state => state.isDarkTheme)
  // We add this here to enable feature flagging via localStorage.
  useFeatureFlags()
  // Get the adapter locale for localization provider
  const adapterLocale = localeMap[languageKey] || localeMap[LanguagesEnum.ENGLISH]

  // Sets date locales for date fns
  setDefaultOptions({ locale: adapterLocale })

  const localeText: Partial<PickersLocaleText> = {
    todayButtonLabel: t('Today'),
    clearButtonLabel: t('Clear'),
    okButtonLabel: t('OK'),
    cancelButtonLabel: t('Cancel'),
  }

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={adapterLocale}
      localeText={localeText}>
      {children}
      <ToasterUI />
    </LocalizationProvider>
  )
}

export default AppLayout
